<style src="./../../assets/styles.css"></style>
<style src="./../../assets/responsive.css"></style>
<template>
    <div>
        <div class="back_to_top" v-on:scroll="calculateScroll">
            <div @click="backToTop">
                <button>Top
                    <v-icon>arrow_upward</v-icon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        },
        created ()
        {
            window.addEventListener('scroll', this.calculateScroll);
        },
        computed: {

        },

        methods: {
            backToTop () {
                $('body,html').animate({
                    scrollTop : 0
                }, 500);
            },
            calculateScroll() {
                $(window).scroll(function() {
                    var $height = $(window).scrollTop();
                    if($height > 300) {
                        $('.back_to_top').show()
                    } else {
                        $('.back_to_top').hide()
                    }
                });
            }
        }
    }
</script>
